export default "__VITE_ASSET__C5jKSfV4__"